module.exports = __webpack_public_path__ + "img/myyq3.20d39dce.jpg";